const openedCollapseIds = state => state.referenceReasonings?.openedCollapseIds || []

export default {
    openedCollapseIds
} 